import { render, staticRenderFns } from "./HeadingInput.vue?vue&type=template&id=8117d4b2&scoped=true"
import script from "./HeadingInput.vue?vue&type=script&lang=ts"
export * from "./HeadingInput.vue?vue&type=script&lang=ts"
import style0 from "./HeadingInput.vue?vue&type=style&index=0&id=8117d4b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8117d4b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8117d4b2')) {
      api.createRecord('8117d4b2', component.options)
    } else {
      api.reload('8117d4b2', component.options)
    }
    module.hot.accept("./HeadingInput.vue?vue&type=template&id=8117d4b2&scoped=true", function () {
      api.rerender('8117d4b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/init-modal/HeadingInput.vue"
export default component.exports